import React from "react";

const chartImages = {
  area: require("../Images/area.png"),
  bar: require("../Images/bar.png"),
  column: require("../Images/column.png"),
  line: require("../Images/line.png"),
  pie: require("../Images/pie.png"),
  stacked_area: require("../Images/stacked-area.png"),
  stacked_bar: require("../Images/stacked-bar.png"),
  stacked_column: require("../Images/stacked-column.png"),
  gauge: require("../Images/gauge.png"),
  radial_bar: require("../Images/radial-bar.png"),
  "3d pie": require("../Images/pie-chart.png"),
  donut: require("../Images/donut-chart.png"),
  "3d donut": require("../Images/3dDonut.png"),
  "3Darea": require("../Images/area.png"),
  speedometer: require("../Images/gauge-circle-plus.png"),
  drillcolumn: require("../Images/columndrilchart.png"),
  custombox: require("../Images/custombox.png"),
};

const charts = [
  { id: "area", value: "Area Chart", title: "Area Chart" },
  { id: "bar", value: "Bar Chart", title: "Bar Chart" },
  { id: "column", value: "Column Chart", title: "Column Chart" },
  { id: "line", value: "Line Chart", title: "Line Chart" },
  { id: "pie", value: "Pie Chart", title: "Pie Chart" },
  { id: "stacked_area",value: "Stacked Area Chart", title: "Stacked Area Chart" },
  { id: "stacked_bar",value: "Stacked Bar Chart", title: "Stacked Bar Chart" },
  { id: "stacked_column",value: "Stacked Column Chart", title: "Stacked Column Chart" },
  { id: "gauge",value: "Gauge Chart", title: "Gauge Chart" },
  { id: "radial_bar", value: "Radial Bar Chart", title: "Radial Bar Chart" },
  { id: "3d pie",value: "3d Pie Chart", title: "3d Pie Chart" },
  { id: "donut",value: "Donut Chart", title: "Donut Chart" },
  { id: "3d donut",value: "3d Donut Chart" , title: "3d Donut Chart" },
  { id: "3Darea",value: "3d Area Chart", title: "3d Area Chart" },
  { id: "speedometer", value: "speedometer", title: "Speedometer Gauge" },
  { id: "drillcolumn", value: "drillcolumn", title: "Column Drilldown" },
  { id: "custombox",value: "custombox", title: "CustomBox" },
].map((chart) => ({
  ...chart,
  value: chart.value,
  imageUrl: chartImages[chart.id],
}));

export default charts;
